import {Button, InputNumber, message, Radio, Space} from 'antd'
import React from 'react'
import {Element, TypedElement} from '../../../../entities/project'
import {useIntl} from 'react-intl'
import {GatewayOutlined} from '@ant-design/icons'

export type EditorCreatePlotRectProps = {
  plot?: TypedElement
  isToolSelected: boolean
  onToolSelected: () => void
  onPlotUpdated: (updatedElement: TypedElement) => void
}

export function EditorCreatePlotRect(props: EditorCreatePlotRectProps) {
  const intl = useIntl()
  return (
    <div>
      <div className="editor-fields-name">{intl.formatMessage({id: 'usePlotDrawingTool'})}:</div>
      <Radio.Group value={props.isToolSelected ? 1 : null}>
        <Radio.Button
          className="editor-fields-radio"
          style={{height: 65}}
          value={1}
          onClick={props.onToolSelected}
        >
          <div className="editor-fields-radio-icon">
            <GatewayOutlined />
          </div>
        </Radio.Button>
      </Radio.Group>

      {props.plot && (
        <Space direction="vertical" className="editor-fields-value">
          <div className="editor-fields-name">
            {intl.formatMessage({id: 'enterPlotEdgesDimensions'})}:
          </div>
          <InputNumber
            style={{width: '100%'}}
            addonBefore={intl.formatMessage({id: 'length'})}
            addonAfter={intl.formatMessage({id: 'm'})}
            value={props.plot?.props.width / 100}
            onChange={(value) => {
              props.onPlotUpdated({
                ...props.plot,
                props: {...props.plot.props, width: value * 100},
              })
            }}
          />
          <InputNumber
            style={{width: '100%'}}
            addonBefore={intl.formatMessage({id: 'width'})}
            addonAfter={intl.formatMessage({id: 'm'})}
            value={props.plot?.props.height / 100}
            onChange={(value) => {
              props.onPlotUpdated({
                ...props.plot,
                props: {...props.plot.props, height: value * 100},
              })
            }}
          />
        </Space>
      )}
      <div></div>
    </div>
  )
}
